import api from './api';
import { PUT } from '../constants/api';

export const uploadFileUsingGCSUrl = (
  url: string,
  data: any,
  onUploadProgress,
) => {
  return api({
    method: PUT,
    url,
    data,
    onUploadProgress,
    headers: {
      'Content-Type': 'text/csv',
    },
  });
};
